import { findDeviceInfo } from './deviceInfo';

const deviceInfo = findDeviceInfo();

export function getLocale() {
    return window.OPTIONS.locale;
}

// TODO tieto dva nazvy [getProperty, getConfigProperty] su dost debilne
export function getProperty(name) {
    return window.OPTIONS[name];
}

export function getConfigProperty(name) {
    return window.OPTIONS.properties[name];
}

window.getConfigProperty = getConfigProperty;

export function getUrl(name) {
    return getProperty('urls')[name];
}

export function getDevice() {
    return deviceInfo;
}

export function formatNumber(num, decimal, afterPeriod, separateThousands) {
    num = num ? parseFloat(num, 10) : 0;
    decimal = decimal !== undefined ? decimal : 2;
    afterPeriod = afterPeriod !== undefined ? afterPeriod : 2;
    separateThousands = separateThousands !== undefined ? separateThousands : true;
    const s = ('' + Math.round(num * Math.pow(10, decimal)) / Math.pow(10, decimal)).split('.');
    s[0] = separateThousands ? s[0].replace(/(\d)(?=(\d{3})+$)/g, '$1 ') : s[0];
    let zeros = '';
    for (let i = 0; i < afterPeriod; i++) {
        zeros += '0';
    }
    s[1] = s[1] ? (s[1] + zeros).substring(0, afterPeriod) : zeros;
    s[1] = s[1].substring(0, afterPeriod);
    return s[1] ? s.join('.') : s[0];
}
